/**
 * Excel refuses to read UTF-8 without this, and staff names routinely carry
 * accents — the alternative is a report with mangled names, which for a
 * compliance document is worse than no report.
 */
const BOM = "\uFEFF";

/** A CSV file's text: a header row, then one row per entry, every cell escaped. */
export function buildCsv(
  header: readonly string[],
  rows: readonly (readonly string[])[],
): string {
  const lines = [header, ...rows].map((cells) =>
    cells.map(escapeCsvCell).join(","),
  );
  return BOM + lines.join("\r\n");
}

/**
 * RFC 4180 quoting, plus a formula-injection guard.
 *
 * A staff name, or a free-text document title, can begin with `=`, `+`, `-` or
 * `@`, which Excel and Sheets execute as a formula on open. Prefixing a tab
 * neutralises that without changing what the cell reads as. This is a real
 * concern here rather than a theoretical one: the values come from user input
 * and the file is opened by managers and inspectors.
 */
export function escapeCsvCell(value: string): string {
  let cell = value ?? "";
  if (/^[=+\-@\t\r]/.test(cell)) {
    cell = `\t${cell}`;
  }
  if (/[",\r\n]/.test(cell)) {
    cell = `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
}
